import { useState, useEffect } from 'react';
import { throttle } from 'lodash';
import { NavConfigsOutpout, StickyNavHeight } from '../constants/navConfigs';

const useCurrentSection = (navConfigs: NavConfigsOutpout, isLaptop: boolean): string => {
  const [currentSection, setCurrentSection] = useState<string>('');

  useEffect(() => {
    const handleScroll = throttle(() => {
      const sections = navConfigs.map((section) => section.elementId);
      const scrollPosition = window.scrollY + StickyNavHeight(isLaptop).numValue * 2;
      const sectionOffsets = sections.map((section) => {
        const element = document.getElementById(section);
        return element ? element.offsetTop : 0;
      });

      let tempCurrentSection = '';
      for (let i = sectionOffsets.length - 1; i >= 0; i -= 1) {
        const isHiddenSection = sectionOffsets[i] === 0 && i !== 0;
        if (scrollPosition >= sectionOffsets[i] && !isHiddenSection) {
          tempCurrentSection = sections[i];
          break;
        }
      }

      setCurrentSection(tempCurrentSection);
    }, 400); // add throttle timing - to improve the performance

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isLaptop, navConfigs]);

  return currentSection;
};

export default useCurrentSection;
